/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { StorageModule } from '@vlinder-web/storage-module-react';
import moment from 'moment-timezone';
import { toHeaderCase } from 'js-convert-case';
import { Graphql } from '@common/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { GET_APPROVED_APPLICATION_ } from '../../api/graphql';
import { dataConfig } from '../../config/approvedApp.config';
import { APPLICATION_TYPE } from '@/config/applicationType.config';
import { APPLICATION_STATUS } from '@/config/applicationStatus.config';

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};
export interface IApprovedAppMethods extends IPluginMethodMap {
  getApprovedApp(args: any): Promise<any>;
}

export class ApprovedAppService implements IAgentPlugin {
  readonly methods: IApprovedAppMethods;

  constructor() {
    this.methods = {
      getApprovedApp: this.getApprovedApp.bind(this),
    };
  }

  private async getApprovedApp(args: any) {
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    const userProfile = storageService.get('myProfile', 'session');
    const role = userProfile?.org?.orgRole;
    const roetable = [
      {
        column: 'type',
        op: 'In',
        value: ['CARICOM_RENEW_WORK_PERMIT', 'CARICOM_NEW_WORK_PERMIT'],
      },
    ];
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      const token = loginSrv()?.getToken();
      console.log(`getUserListsProps service token`, token);
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      if (client) {
        const res = await client.query(GET_APPROVED_APPLICATION_, {
          input: {
            skip: args?.offset,
            limit: args?.size,
            where: [
              ...(args?.where ?? []),
              ...(role === 'CARICOM_BUSSINESS_ORG' ? roetable : []),
              {
                column: 'status',
                op: 'In',
                value: ['PROCESSED', 'CARD_DISTRIBUTED','DISTRIBUTED','LETTER_DISTRIBUTED'],
              },
            ],
            order: [
              {
                column: 'updatedAt',
                direction: 'DESC',
              },
            ],
          },
        });
        if (res?.data) {
          console.log(`table data`, res);
          let _rowData = this.formatUserTable(
            res?.data?.getListOfApplication?.data
          );
          console.log(`row data`, _rowData);
          return {
            ...dataConfig,
            ultUsers: _rowData,
            userRoles: res?.data?.getRoleList?.data,
            isEmpty: _rowData
              ? res?.data?.getListOfApplication?.data?.length <= 0
              : true,
            // studentGroup: holderGroups,
            activePage: res?.data?.getListOfApplication?.currentPage,
            pageSize: res?.data?.getListOfApplication?.pageSize,
            totalCount: res?.data?.getListOfApplication?.totalCount,
            totalPages: res?.data?.getListOfApplication?.totalPages,
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      throw err;
    }
  }

  private formatUserTable(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any, index: number) => {
        return {
          id: item?.applicationNo,
          // status: item?.status,
          name: item?.applicantInfo?.firstName
            ? `${
                item?.applicantInfo?.lastName
                  ? toHeaderCase(item?.applicantInfo?.lastName ?? '')
                  : ''
              }, ${toHeaderCase(item?.applicantInfo?.firstName)}`
            : // ${
              //     item?.applicantInfo?.middleName
              //       ? toHeaderCase(item?.applicantInfo?.middleName ?? '')
              //       : ''
              //   }`
              '',

          appliedOn: this.formatCreatedDate(item?.createdAt),
          status: this.getFormattedStatus(item?.status, item?.displayStatus),
          applicationId: item?.applicationNo,
          type: this.getFormattedType(item?.type),

          nationality: item?.applicantInfo?.nationality ?? '-',
        };
      });

    return _rowData;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format('LLL');
    }
  }
  private getFormattedType(type: string) {
    if (APPLICATION_TYPE?.[type]) {
      return APPLICATION_TYPE?.[type];
    }
    return '-';
  }
  private getFormattedStatus(status: string,displayStatus: string) {
    if (displayStatus === 'INCOMPLETE') {
      if (APPLICATION_STATUS?.[status]) {
        return APPLICATION_STATUS?.[status];
      }
    }
    if (displayStatus === 'PAYMENT_REQUIRED') {
      if (APPLICATION_STATUS?.[status]) {
        return APPLICATION_STATUS?.[status];
      }
    }
    
    else {
      if (APPLICATION_STATUS?.[displayStatus]) {
        return APPLICATION_STATUS?.[displayStatus];
      }
    }
    return '-';
  }
}
